export default __webpack_public_path__ + "static/media/NCIndia.9c5c26a0.png";